import React from "react";
import {Query} from "react-apollo";
import {fromJS, List} from "immutable";
import PanelGroupController from "../../../components/PanelGroupController";
import PropertiesList from "../../../components/panels/PropertiesList";
import InlineTable from "../../../components/InlineTable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {GET_STOCK_TRANSFER} from "../../../queries/stockTransfers";
import {skuSummaryRows} from "../../shared/SkuSummary";
import {statusLabel} from "../statusDisplay";
import {adviceSentText} from "../../shared/AdviceSent";

const PROPERTIES = fromJS([
  {prop: "id", label: "Id", type: "id"},
  {prop: "statusLabel", label: "Status", type: "string"},
  {prop: "originWarehouseId", label: "Origin", type: "id"},
  {prop: "destinationWarehouseId", label: "Destination", type: "id"},
  {prop: "transportType", label: "Type", type: "string"},
  {prop: "carrierReference", label: "Carrier Reference", type: "string"},
  {prop: "adviceSentText", label: "Shipment Advice", type: "string"},
  {prop: "archiveText", label: "Archived", type: "string"},
  {prop: "purchaseOrder", label: "Purchase Order", type: "string"},
  {prop: "orderDate", label: "Order Date", type: "string"},
  {prop: "expectedArrivalDate", label: "Expected Arrival", type: "string"},
  {prop: "dispatchedAt", label: "Dispatched", type: "utc"},
  {prop: "receivedAt", label: "Received", type: "utc"},
  {prop: "cancelledAt", label: "Cancelled", type: "utc"},
  {prop: "totalQuantity", label: "Total Quantity", type: "number"},
]);

const SUMMARY_FIELDS = fromJS([
  {field: "sku", title: "SKU"},
  {field: "quantity", title: "Qty"},
]);

const RECEIVED_FIELD = fromJS({field: "receivedQuantity", title: "Received"});

// The transfer's details, and what it adds up to per SKU.
const StockTransferInfoPanel = ({transferId, expanded}) => (
  <PanelGroupController title="Transfer Info" expanded={expanded}>
    <Query query={GET_STOCK_TRANSFER} variables={{id: transferId}} fetchPolicy="cache-and-network">
      {({loading, error, data}) => {
        if (loading && !(data && data.stockTransfer)) return <Loading />
        if (error) return <GraphQLErrors error={error} />
        if (!data.stockTransfer) return <p className="u-no-selection">Transfer not found</p>

        const transfer = fromJS(data.stockTransfer);
        const isReceived = transfer.get("status") === "received";
        const rows = skuSummaryRows(transfer.get("lines", List()));

        return (
          <React.Fragment>
            <PropertiesList properties={PROPERTIES} data={transfer
              .set("statusLabel", statusLabel(transfer.get("status")))
              .set("adviceSentText", adviceSentText(data.stockTransfer))
              .set("archiveText", transfer.get("archived")
                ? `From shipment advice ${transfer.get("adviceReference")} (receipt not recorded)`
                : "")} />
            {rows.size > 0 &&
              <React.Fragment>
                <br />
                <InlineTable
                  data={rows}
                  itemKey="sku"
                  fields={isReceived ? SUMMARY_FIELDS.push(RECEIVED_FIELD) : SUMMARY_FIELDS}
                  dataType="sku_summary"
                  />
              </React.Fragment>}
          </React.Fragment>
        )
      }}
    </Query>
  </PanelGroupController>
);

StockTransferInfoPanel.defaultProps = {
  expanded: true
};

export default StockTransferInfoPanel;
